import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import * as UserService from "../../Services/User/UserService";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { FaSpinner } from "react-icons/fa";
import Multiselect from "multiselect-react-dropdown";

const RoleUserAccessMappingModal = ({
  showModal,
  setShowModal,
  orgNames,
  fetchUniversalRoleUserAccessMasterList,
  activeRoleList,
  accessControlList,
}) => {
  const [accessMappingList, setAccessMappingList] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (accessControlList?.length) {
      const normalized = accessControlList.map((item) => ({
        ...item,
        IsSelected: false,
        IsDeleted: false,
      }));
      setAccessMappingList(normalized);
    }
  }, [accessControlList]);

  const handleMappingInsert = (Access_Control_Id) => {
    setAccessMappingList((prev) =>
      prev.map((item) =>
        item.Access_Control_Id === Access_Control_Id
          ? { ...item, IsSelected: true, IsDeleted: false }
          : item,
      ),
    );
  };

  const handleMappingDelete = (Access_Control_Id) => {
    setAccessMappingList((prev) =>
      prev.map((item) =>
        item.Access_Control_Id === Access_Control_Id
          ? { ...item, IsSelected: false, IsDeleted: true }
          : item,
      ),
    );
  };

  const onSubmit = (data) => {
    setLoading(true);

    data.UserRightsDet = accessMappingList.filter((a) => a.IsSelected === true);

    const payload = {
      Role_Id: data.Role_Name.value,
      Role_Name: data.Role_Name.label,
      UserRightsDet: data.UserRightsDet,
    };

    //console.log(payload);

    UserService.AddRoleAccessMapping(payload)
      .then(({ data }) => {
        if (data.IsSuccess) {
          toast.success(data.ResponseMessage);
          reset();
          setShowModal(false);
          fetchUniversalRoleUserAccessMasterList();
        } else {
          toast.error(data.ResponseMessage);
        }
      })
      .catch(() => toast.error("Something went wrong during creation."))
      .finally(() => {
        setLoading(false);
      });
  };

  const renderError = (fieldName, errors) => {
    if (!errors || !fieldName) return null;
    const error = errors[fieldName];
    return error ? <p className="text-danger">{error.message}</p> : null;
  };

  return (
    <div>
      <div className="modal-backdrop">
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div
            className="modal-dialog modal-lg custom-modal-com"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Mapping</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowModal(false);
                  }}
                ></button>
              </div>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-lg-4 col-12 mb-2">
                      <label className="fw-bold required mb-2">
                        Role Name{" "}
                      </label>

                      <Controller
                        name="Role_Name"
                        control={control}
                        rules={{ required: "Role_Name is required" }}
                        render={({ field }) => (
                          <Select
                            options={activeRoleList?.map((item) => ({
                              value: item.Role_Id,
                              label: item.Role_Name,
                            }))}
                            placeholder="-- Select Role Name  --"
                            isSearchable
                            value={field.value}
                            onChange={(option) => field.onChange(option)}
                            onBlur={field.onBlur}
                          />
                        )}
                      />

                      {renderError("Role_Name", errors)}
                    </div>

                    <div className="col-lg-8 col-12 mb-2">
                      <label className="fw-bold required mb-2">
                        Access Control Name
                      </label>
                      <Multiselect
                        options={accessMappingList}
                        selectedValues={accessMappingList.filter(
                          (item) => item.IsSelected,
                        )}
                        displayValue="Access_Control_Name"
                        placeholder="Select Allowed Access"
                        onSelect={(selectedList, selectedItem) =>
                          handleMappingInsert(selectedItem.Access_Control_Id)
                        }
                        onRemove={(selectedList, removedItem) =>
                          handleMappingDelete(removedItem.Access_Control_Id)
                        }
                      />

                      {renderError("Access_Control_Name", errors)}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-danger"
                    tabIndex={-1}
                    onClick={() => {
                      setShowModal(false);
                    }}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn custom-sumbitbtn">
                    {loading ? <FaSpinner className="fa-spin mb-1" /> : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleUserAccessMappingModal;
